/**
 * Single source of truth for "where is the backend?" — used by every page that
 * makes /v1/* calls. Routes by `window.location.hostname`:
 *
 *   localhost / 127.0.0.1                  → ''                                (vite proxy)
 *   staging.wholisphere.{ai,com}           → https://staging-api.wholisphere.ai
 *   *.pages.dev                            → https://staging-api.wholisphere.ai
 *   app.wholisphere.{ai,com}               → https://api.wholisphere.ai
 *   anything else                          → https://api.wholisphere.ai        (safe default)
 *
 * The .com domain is kept as a legacy alias; .ai is the canonical brand.
 */

const PROD_BACKEND_URL = 'https://api.wholisphere.ai';
const STAGING_BACKEND_URL = 'https://staging-api.wholisphere.ai';

export const apiBase = (): string => {
  if (typeof window === 'undefined') return PROD_BACKEND_URL;
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return '';
  if (
    host === 'staging.wholisphere.ai' ||
    host === 'staging.wholisphere.com' ||
    host.endsWith('.pages.dev')
  ) {
    return STAGING_BACKEND_URL;
  }
  return PROD_BACKEND_URL;
};

/** Human-readable form of the current backend, for display in the dashboard. */
export const apiBaseLabel = (): string => {
  const base = apiBase();
  if (!base) return 'localhost (vite proxy)';
  return base.replace('https://', '');
};
